import * as React from 'react';
import { DashboardRoute, LoginRoute } from '~/Application/routes';
import { ApplicationError } from '~/ApplicationError';
export var NotFound = function () { return (<section>
		<div className='in'>
			<div className='form-content'>
				<span>{ApplicationError.resourceNotFound}</span>
				<p>
					Pokračujte na{' '}
					<DashboardRoute.Link>
						<a>úvodní stránku</a>
					</DashboardRoute.Link>{' '}
					nebo na{' '}
					<LoginRoute.Link>
						<a>přihlášení</a>
					</LoginRoute.Link>
					.
				</p>
			</div>
		</div>
	</section>); };
NotFound.displayName = 'Application.NotFound';
